var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list-item-subtitle',{staticClass:"message-preview"},[(_vm.origin != 'customer')?_c('v-icon',{staticClass:"mr-1",attrs:{"size":"16","color":_vm.status >= 4 ? 'blue' : 'grey lighten-1'}},[_vm._v(" mdi-check-all ")]):_vm._e(),_c('span',{domProps:{"innerHTML":_vm._s(_vm.renderedMessage)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }